export const RouteSegments = {
  EESE_COVERAGE: 'eesecoverage',
  SPECIFICATION_COVERAGE: 'specificationcoverage',
  SOFTWARE_VERSION_COVERAGE: 'softwareversioncoverages',
  RMS_SPECIFICATIONS_COMPARISON: 'rmsspecificationcomparison',
  EVALUATION: 'evaluation',
  TEST_ANALYSIS: 'testanalyses',
  TEST_CASES: 'testcases',
  TEST_SUITES: 'testsuites',
  TEST_SPECIFICATIONS: 'testspecifications',
  ADD: 'add',
  IMPORT: 'import',
  REVIEW: 'review'
};

export const RouteConstants = {
  EESE_COVERAGE: `${RouteSegments.EESE_COVERAGE}`,
  SPECIFICATION_COVERAGE: `${RouteSegments.SPECIFICATION_COVERAGE}`,
  SOFTWARE_VERSION_COVERAGE: `${RouteSegments.SOFTWARE_VERSION_COVERAGE}`,
  RMS_SPECIFICATIONS_COMPARISON: `${RouteSegments.RMS_SPECIFICATIONS_COMPARISON}`,
  EVALUATION: `${RouteSegments.EVALUATION}`,
  TEST_ANALYSIS: `${RouteSegments.TEST_ANALYSIS}`,
  TEST_CASES: `${RouteSegments.TEST_CASES}`,
  TEST_SUITES: `${RouteSegments.TEST_SUITES}`,
  TEST_SPECIFICATIONS: `${RouteSegments.TEST_SPECIFICATIONS}`,
  REVIEW: `${RouteSegments.REVIEW}`,
  BASE: '',
};

export const RouteParams = {
  TestItemUid: 'testitemuid',
};

export const PageHeaders = {
  EESE_COVERAGE: 'EESE Coverages',
  SPECIFICATION_COVERAGE: 'Specification Coverages',
  SOFTWARE_VERSION_COVERAGE: 'Software Version Coverage',
  RMS_SPECIFICATIONS_COMPARISON: 'RMS Specifications Comparison',
  EVALUATION: 'Evaluation',
  TEST_ANALYSIS: 'Test Analyses',
  TEST_CASES: 'Test Cases',
  TEST_SUITES: 'Test Suites',
  TEST_SPECIFICATIONS: 'Test Specifications',
};

export const SEGMENT_TO_HEADER: Record<string, string> = {
  [RouteSegments.EESE_COVERAGE]: PageHeaders.EESE_COVERAGE,
  [RouteSegments.SPECIFICATION_COVERAGE]: PageHeaders.SPECIFICATION_COVERAGE,
  [RouteSegments.SOFTWARE_VERSION_COVERAGE]: PageHeaders.SOFTWARE_VERSION_COVERAGE,
  [RouteSegments.RMS_SPECIFICATIONS_COMPARISON]: PageHeaders.RMS_SPECIFICATIONS_COMPARISON,
  [RouteSegments.EVALUATION]: PageHeaders.EVALUATION,
  [RouteSegments.TEST_ANALYSIS]: PageHeaders.TEST_ANALYSIS,
  [RouteSegments.TEST_CASES]: PageHeaders.TEST_CASES,
  [RouteSegments.TEST_SUITES]: PageHeaders.TEST_SUITES,
  [RouteSegments.TEST_SPECIFICATIONS]: PageHeaders.TEST_SPECIFICATIONS
};